import { httpservice, Message } from 'src/app/commons/commons.module';
import { Component, OnInit,Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { PravniDokumentVrsta } from 'src/app/_models/pravnidokumentvrsta';


@Component({
  selector: 'dokumentvrstaAdd',
  templateUrl: './dokumentvrstaAdd.component.html'
})
export class DokumentVrstaAddComponent implements OnInit {
  getservice: httpservice;
  data: PravniDokumentVrsta = {pravniDokumentVrstaId:0,sifra:"",naziv:"",pravniDokumentTekstIspisId:0};
  loading = false;
  submitted = false;
  status: string = "";
  returnUrl: string;
  error = '';
  editing = false;
  poruka = "Dodavanje";
  @Input() item: 0;
  @Output() newItemEvent = new EventEmitter<PravniDokumentVrsta>();
  listatekstova: any;

  constructor(dataservice: httpservice, private router: Router, private route: ActivatedRoute, private location: Location) {
    this.getservice = dataservice;       
  }
  ngOnInit() {
    this.UcitajTekstove();
    if (this.item > 0) {
      this.getClient(this.item.toString());
    }
    else {
      var idkor = this.route.snapshot.paramMap.get('id');
      if (idkor != null) {
        this.getClient(idkor);
      }
      else {
        idkor = "0";
      }
    }
  }

  UcitajTekstove() {
    this.getservice.GetRequest<Message>("komunalno/saldakonti/dokumenttekstispis/List").subscribe(result => {
      if (result.status === "success") {
        this.listatekstova = Object.values(result.data);
      }
    }, error => console.error('Get tekstove', error));
  }


  

  addClient() {
    this.submitted = true;
    this.loading = true;
    
      if (!this.editing) {
        this.getservice.PostRequest<Message>("komunalno/saldakonti/dokumentvrsta/add", this.data).subscribe(result => {
          if (result.status === "success")
          {
            this.data.pravniDokumentVrstaId = result.data;
            this.newItemEvent.emit(this.data);
            //this.router.navigate(['/komunalno/saldakonti/utuzivanje/dokument']);
          }
          else {
            this.loading = false;
            this.error = result.data;
            console.error('Log error', result);
          }
        },
          error => {
            this.loading = false;
            console.error('Log error', error);
          });
      }
      else {
        this.getservice.PostRequest<Message>("komunalno/saldakonti/dokumentvrsta/edit", this.data).subscribe(result => {
          if (result.status === "success") {
            this.newItemEvent.emit(this.data);
            //this.router.navigate(['/komunalno/saldakonti/utuzivanje/dokument']);
          }
          else {
            this.loading = false;
            console.error('Log error', result);
          }
        }, error => console.error('Log error',error));
      }        
  }


  goBack() {
    //this.location.back();
    this.data.pravniDokumentVrstaId = 0;
    this.newItemEvent.emit(this.data);
  }   

  getClient(id: string) {
    this.getservice.GetRequest<Message>("komunalno/saldakonti/dokumentvrsta/Get?id=" + id).subscribe(result => {
      if (result.status === "success") {
        this.editing = true;
        this.poruka = "Ispravak";
        this.data = result.data;
      }
    });
  }

}
